module.exports = __webpack_public_path__ + "static/img/16.5469ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/16.png
// module id = 40R+
// module chunks = 1